import * as React from "react";
import {useEffect, useState} from "react";
import {collection, onSnapshot} from "firebase/firestore";
import {db} from "./Admin";
import css from "../css/admin.module.css";


export const Problems = () => {
    const [problems, setProblems] = useState(null);
    const [settings, setSettings] = useState(null);
    const [solvings, setSolvings] = useState(null);

    useEffect(() => {
        const unsubscribes = [];
        unsubscribes.push(onSnapshot(collection(db, "settings"), s => setSettings(s.docs.reduce((a, c) => ({
            ...a,
            [c.id]: c.data()
        }), {}))));
        unsubscribes.push(onSnapshot(collection(db, "problems"), s => {
            const d = s.docs.map(doc => doc.id.split("-").slice(0, -1).join("-")).reduce((a,c)=>{
                a[c] = a[c] || 0;
                a[c]++;
                return a
            }, {})
            setProblems(d)
        }));
        unsubscribes.push(onSnapshot(collection(db, "solvings"), s => {
            const solvings = s.docs.map(c =>
                Object.entries(c.data())
                    .filter(d => d[1].isRight)
                    .map(d => d[0].split("-").slice(0, -1).join("-"))
                    .reduce((a,c)=>{
                        a[c] = a[c] || 0;
                        a[c]++;
                        return a
                    }, {})
            ).reduce((a,c)=> {
                for(const key in c){
                    a[key] = Math.max(a[key] || 0, c[key])
                }
                return a
            }, {});


            setSolvings(solvings)

        }));

        return () => unsubscribes.forEach(unsubscribe => unsubscribe())
    }, []);

    if(!problems || !settings || !solvings) return ;

    const courses = settings?.props?.courses ? settings.props.courses.reduce((a, c) => ({
        ...a,
        [c.id]: c.text
    }), {}) : {};


    return (
        <div className={css.problems}>
            <table>
                <thead>
                <tr>
                    <th>Title</th>
                    <th>Problems</th>
                    <th>Max Solvings</th>
                </tr>
                </thead>
                <tbody>
                    {Object.entries(courses).map(([id, title])=>(
                        <tr key={id}>
                            <td>{title}</td>
                            <td>{problems[id]}</td>
                            <td>{solvings[id]}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
